import { apiClient } from './client';

export const referralApi = {
  getAll: (params) => apiClient.get('/referrals', { params }),
  getById: (id) => apiClient.get(`/referrals/${id}`),
  create: (data) => apiClient.post('/referrals', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update: (id, data) => apiClient.put(`/referrals/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  assign: (id, doctorId) => apiClient.patch(`/referrals/${id}/assign`, { doctorId }),
  reject: (id, reason) => apiClient.patch(`/referrals/${id}/reject`, { reason }),
  getAuditLogs: (id) => apiClient.get(`/referrals/${id}/audit-logs`),
  addAttachments: (id, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('attachments', file));
    return apiClient.post(`/referrals/${id}/attachments`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  removeAttachment: (id, attachmentPath) => apiClient.delete(`/referrals/${id}/attachments`, { data: { path: attachmentPath } }),
  submitReport: (id, { diagnosisSummary, treatmentSummary, files }) => {
    const formData = new FormData();
    if (diagnosisSummary) { formData.append('diagnosisSummary', diagnosisSummary); }
    if (treatmentSummary) { formData.append('treatmentSummary', treatmentSummary); }
    (files || []).forEach((file) => formData.append('attachments', file));
    return apiClient.post(`/referrals/${id}/report`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  delete: (id) => apiClient.delete(`/referrals/${id}`),
};
